'use strict';

/**
 * Create a HubSpot contact. `kind` is always 'contact' and is kept as an
 * argument so the modal can take another record type again later.
 *
 * Companies are NOT creatable here any more: a job's company comes from its
 * account, and a per-job create is what filled the portal with duplicates.
 *
 * Only the minimum HubSpot needs is asked for, and the created record is
 * returned so the caller can select it straight away.
 */
angular.module('enervexSalesappApp').controller('HubspotRecordModalCtrl', function($scope, $uibModalInstance, HubspotDealsService, kind, prefill) {
	$scope.kind = kind;
	$scope.saving = false;
	$scope.error = null;
	$scope.record = {
		name: '',
		domain: '',
		email: '',
		firstname: '',
		lastname: ''
	};

	// whatever was typed into the search box is a reasonable starting value
	if (prefill && prefill !== '' && prefill.indexOf('@') > -1) {
		$scope.record.email = prefill;
	}

	$scope.title = 'Create HubSpot Contact';

	$scope.valid = function() {
		return ($scope.record.email || '').trim() !== '';
	};

	$scope.create = function() {
		if (!$scope.valid() || $scope.saving) {
			return;
		}
		$scope.saving = true;
		$scope.error = null;
		var call = HubspotDealsService.createContact({
			email: $scope.record.email,
			firstname: $scope.record.firstname,
			lastname: $scope.record.lastname
		});

		call.$promise.then(function(created) {
			$scope.saving = false;
			$uibModalInstance.close(created);
		}).catch(function(err) {
			$scope.saving = false;
			$scope.error = (err && err.data && err.data.message) ?
				err.data.message : 'Could not create the record in HubSpot.';
		});
	};

	$scope.dismiss = function() {
		$uibModalInstance.dismiss(false);
	};
});
